import { configureBrandFromEnv } from '@parsina/framework/ui/lib/brand';

// The brand, configured ONCE, before anything else in the panel evaluates
// (docs/rebranding/CONTRACT.md). App.jsx imports this file first: import order
// is evaluation order, and modules below read the brand while they load — the
// locale registry, the shared clinical module (the visit room follows it on its
// own), the language picker's list.
//
// docker-entrypoint.sh writes `BRAND_B64` into env.js only when the container
// has a brand (BRAND_JSON or BRAND_B64). Absent, this changes nothing and the
// panel is Parsina, byte for byte; a value that does not decode is Parsina too,
// with one console warning — a brand is never the reason a desk does not start.
configureBrandFromEnv();
